import { HttpAxiosLoggingClient } from '@/services/api/clients/HttpAxiosLoggingClient';
import type { IHttpClient } from '@/services/api/HttpClient';
import { HttpLoggingServiceProvider } from '@/services/api/HttpLoggingServiceProvider';
import { LOGGER_MODULE } from '@/services/logger/types';
import { useLogger } from '@/services/logger/useLogger';

let httpClientInstance: IHttpClient;
let httpServiceProvider: HttpLoggingServiceProvider;

const createDefaultHttpAxiosClient = () => {
  return new HttpAxiosLoggingClient(
    useLogger(LOGGER_MODULE.AXIOS),
    undefined,
    undefined,
  );
};

export const useLoggingApi = (
  newHttpClient?: IHttpClient,
  forceNewInitialisation = false,
): HttpLoggingServiceProvider => {
  if (httpClientInstance === undefined || forceNewInitialisation) {
    httpClientInstance = newHttpClient || createDefaultHttpAxiosClient();
  }

  if (httpServiceProvider === undefined || forceNewInitialisation) {
    httpServiceProvider = new HttpLoggingServiceProvider(httpClientInstance);
  }

  return httpServiceProvider;
};

export const getLoggingHttpClientInstance = () => {
  if (httpClientInstance === undefined) {
    httpClientInstance = createDefaultHttpAxiosClient();
  }

  return httpClientInstance;
};
